import styled from 'styled-components';

export const Container = styled.div`
  .card {
    background-color: #ffffff !important;
    border: 1px solid #e2e5ea;
    border-radius: 20px;
    box-shadow: 0 1px 2px rgba(33, 53, 74, 0.04), 0 8px 24px rgba(33, 53, 74, 0.06);
  }

  .card-body {
    padding: 40px 36px !important;
  }

  .card-title {
    color: #21354a !important;
    font-size: 22px;
    font-weight: 700;
    text-align: center;
    letter-spacing: -0.01em;
  }

  label {
    font-size: 14px;
    font-weight: 500;
    color: #21354a;
  }

  .form-control {
    height: 48px;
    border: 1px solid #e2e5ea;
    border-radius: 12px;
    font-size: 15px;
    padding: 0 16px;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &::placeholder {
      color: #8a94a3;
    }

    &:hover {
      border-color: #cbd1d9;
    }

    &:focus {
      border-color: ${(props) => props.theme.$bg_green_register};
      box-shadow: 0 0 0 3px rgba(13, 135, 94, 0.18);
    }
  }

  .password-wrap {
    position: relative;

    .form-control {
      padding-right: 48px;
    }
  }

  .eye-btn {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    background: transparent;
    border: 0;
    padding: 6px;
    color: #8a94a3;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    .material-icons {
      font-size: 20px;
    }

    &:hover {
      color: #21354a;
    }
  }

  .btn-submit {
    height: 52px;
    background: ${(props) => props.theme.$bg_green_register};
    color: #ffffff;
    border: 0;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    transition: background 0.15s ease, transform 0.05s ease;

    &:hover {
      background: ${(props) => props.theme.$dark_green};
      color: #ffffff;
    }

    &:active {
      transform: translateY(1px);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .terms-text {
    font-size: 13px;
    color: #5f6b7a;
    line-height: 1.5;

    a {
      color: #21354a;
      text-decoration: underline;
      text-underline-offset: 2px;
      font-weight: 500;

      &:hover {
        color: #000;
      }
    }
  }

  @media (max-width: 720px) {
    .card-body {
      padding: 28px 20px !important;
    }
  }
`;
